import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import VueCryptojs from "@/plugins/cryptojs";
import VueLazyload from "@/plugins/lazyload";
import VueSweetalert2 from "@/plugins/sweetalert";
import aos from "@/plugins/aos";
import apiPlugin from "@/plugins/api";
import global from "@/plugins/global";
import "./registerServiceWorker";
import filters from "./filters/filters";
import ComponentsRegister from "@/plugins/ComponentsRegister";

Vue.use(global);
Vue.use(apiPlugin);
Vue.filter(filters);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  ComponentsRegister,
  VueCryptojs,
  VueLazyload,
  VueSweetalert2,
  aos,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
